/**
 * @one-payments/adapters-native - React Native platform adapters
 * @module @one-payments/adapters-native
 */

import type { Adapters } from '@one-payments/core';
import { NativeHttpAdapter } from './http.js';
import { NativeStorageAdapter } from './storage.js';
import { NativeCryptoAdapter } from './crypto.js';
import { NativeTimerAdapter } from './timer.js';

export { NativeHttpAdapter } from './http.js';
export { NativeStorageAdapter } from './storage.js';
export { NativeCryptoAdapter } from './crypto.js';
export { NativeTimerAdapter } from './timer.js';

/**
 * Create native adapters - convenience factory function
 */
export function createNativeAdapters(): Adapters {
  return {
    http: new NativeHttpAdapter(),
    storage: new NativeStorageAdapter(),
    crypto: new NativeCryptoAdapter(),
    timer: new NativeTimerAdapter(),
  };
}
